/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-12 14:44:08
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-12 14:52:22
 * @FilePath: /unifyxp-v2-store-portal/src/layout/EditorPageLayout/SectionTitle/StyledTitle.tsx
 */
import React from 'react';
import css from './css.module.less';
import SectionTitle from './index';
const Title = ({ left, right, leftBottom }) => {
  return (
    <div className={css.styledTitleContainer}>
      {(left || leftBottom) && (
        <div className={css.leftPartContainer}>
          <div>{left}</div>
          <div className={css.leftBottomContainer}>{leftBottom}</div>
        </div>
      )}
      {right && <div className={css.rightPartContainer}>{right}</div>}
    </div>
  );
};
const StyledTitle = (props) => {
  const { left, right, leftBottom } = props;
  return (
    <SectionTitle
      containerClassName={css.styledContainer}
      title={<Title leftBottom={leftBottom} left={left} right={right} />}
    />
  );
};
export default StyledTitle;
